exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-regenerate-body[data-v-cf9798a4]{padding:4px 2px}.ai-regenerate-tip[data-v-cf9798a4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;font-size:12px;color:#808695;background:#f7f9fc;padding:8px 12px;border-radius:4px;margin-bottom:14px}.ai-regenerate-tip i[data-v-cf9798a4]{color:#2d8cf0;font-size:14px}.ai-regenerate-field .ai-regenerate-label[data-v-cf9798a4]{font-size:13px;font-weight:600;color:#17233d;margin-bottom:6px}", ""]);

// exports
